import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1),
  px: theme.spacing(2.5),
  py: theme.spacing(1),
  borderRadius: Number(theme.shape.borderRadius) * 3,
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  boxShadow: theme.shadows[1],
});

export const label: SxProps<Theme> = {
  color: "text.secondary",
  fontWeight: 600,
};

export const value: SxProps<Theme> = {
  color: "text.primary",
  fontWeight: 700,
};
